import { Empty } from "antd";
import LoadingOverlay from "components/atoms/LoadingOverlay";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppState from "store/AppState";
import { getDataObjectPermissionRequest } from "store/dataObjects/actions";
import BasicFormBuilder from "../BasicFormBuilder";
import ProhibitedArea from "../ProhibitedArea";

export default function DataSetRecordForm({
    isLoading,
    loadingMessage = "Getting dataset record...",
    isProhibited,
    dataObject,
    schemaModel,
    onCancel,
    onSave,
}: IDataSetRecordFormProps) {
    const [editMode, setEditMode] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const dispatch = useDispatch();
    const dataObjectPermission = useSelector((state: AppState) => state.dataObjects.dataObjectPermission);

    useEffect(() => {
        if (dataObjectPermission?.canEdit) {
            setCanEdit(true);
        } else {
            setCanEdit(false);
        }
    }, [dataObjectPermission]);

    useEffect(() => {
        dispatch(getDataObjectPermissionRequest());
    }, [dispatch]);

    const handleCancel = useCallback(() => {
        setEditMode(false);
        onCancel && onCancel();
    }, [onCancel]);

    return isProhibited ? (
        <ProhibitedArea />
    ) : isLoading ? (
        <LoadingOverlay busy={true} message={loadingMessage} />
    ) : dataObject ? (
        <>
            <BasicFormBuilder
                key={dataObject.dataObjectId}
                formDataObject={dataObject}
                schemaFields={schemaModel ? schemaModel.fields : []}
                readOnly={!canEdit || !editMode}
                showRevealButton={true}
                onCancel={handleCancel}
                onUpdate={onSave}
                showHeader={false}
                onTriggerEdit={() => setEditMode(true)}
            ></BasicFormBuilder>
        </>
    ) : (
        <div className="flex flex-1 items-center justify-center">
            <Empty description="No record found" />
        </div>
    );
}
